<template>
  <div class="userCenter">
    <div class="content" v-if="vipLis.length">
      <div class="user-card">
        <div class="avatar-wrap" @click="triggerAvatarUpload">
          <img :src="userAvatar" alt="用户头像" class="avatar-img">
          <input ref="avatarInput" type="file" @change="onchangemd" accept="image/gif,image/png" class="avatar-input">
          <div class="avatar-edit-mask"><i class="fas fa-camera"></i></div>
        </div>
        <div class="user-info" @click="$parent.goNav('/vip')">
          <div class="user-name-row">
            <h3 class="user-name">{{ $store.state.userInfo.username }}</h3>
            <img 
              :src="vipIconSrc" 
              alt="VIP标识" 
              class="vip-icon" 
              v-if="shouldShowVipIcon"
              @error="handleVipIconError"
            >
          </div>
          <div class="vip-progress">
            <div class="progress-bg"><div class="progress-fill" :style="`width: ${bfNum}%`"></div></div>
            <span class="vip-level">VIP{{ nextVipLevel }}</span>
          </div>
          <p class="total-recharge">累计充值 ¥{{ (Number($store.state.userInfo.paysum) || 0) }}元</p>
        </div>
        <div class="go-account" @click="$parent.goNav('/accountCenter')"><i class="fas fa-chevron-right"></i></div>
      </div>
      <div class="asset-card">
        <div class="asset-header">
          <div class="header-left">
            <h4 class="asset-title">总资产</h4>
            <span class="eye-icon" @click="toggleBalanceVisible">
              <i class="fas" :class="isBalanceVisible ? 'fa-eye' : 'fa-eye-slash'"></i>
            </span>
          </div>
          <div class="recycle-btn" @click="transall">
            <span>一键回收</span><i class="fas fa-chevron-right"></i>
          </div>
        </div>
        <div class="asset-value-row">
          <h2>{{ isBalanceVisible ? $store.state.userInfo.balance : '******' }}</h2>
          <div class="transfer-btn" @click="$parent.goNav('/assets')">
            <span>转账</span><i class="fas fa-chevron-right"></i>
          </div>
        </div>
      </div>
      <div class="function-grid">
        <div class="func-item" @click="$parent.goNav('/deposit')">
          <div class="func-icon bg-blue"><i class="fas fa-coins"></i></div>
          <p>充值</p>
        </div>
        <div class="func-item" @click="$parent.goNav('/assets?type=0')">
          <div class="func-icon bg-green"><i class="fas fa-exchange-alt"></i></div>
          <p>交易</p>
        </div>
        <div class="func-item" @click="$parent.goNav('/assets?type=4')">
          <div class="func-icon bg-purple"><i class="fas fa-ticket-alt"></i></div>
          <p>投注</p>
        </div>
        <div class="func-item" @click="$parent.goNav('/assets?type=5')">
          <div class="func-icon bg-orange"><i class="fas fa-hand-holding-usd"></i></div>
          <p>返水</p>
        </div>
        <div class="func-item" @click="$parent.goNav('/withdraw')">
          <div class="func-icon bg-red"><i class="fas fa-arrow-circle-down"></i></div>
          <p>取款</p>
        </div>
      </div>
      <div class="feature-list">
        <div class="list-item" @click="$parent.goNav('/welfare')">
          <div class="list-left"><div class="list-icon bg-red"><i class="fas fa-gift"></i></div><p>福利中心</p></div>
          <div class="list-right"><span class="tag-red">红包多多</span><i class="fas fa-chevron-right"></i></div>
        </div>
        <div class="list-item" @click="$parent.goNav('/myNews')">
          <div class="list-left"><div class="list-icon bg-blue"><i class="fas fa-bell"></i></div><p>我的消息</p></div>
          <i class="fas fa-chevron-right"></i>
        </div>
        <div class="list-item" @click="$parent.goNav('/yaoqing')">
          <div class="list-left"><div class="list-icon bg-red"><i class="fas fa-gift"></i></div><p><img src="/static/image/agent_tips.d596f5ec.gif" style="height: 18px;width: 60px;"></p></div>
          <div class="list-right"><img src="/static/image/agent_friend.b18c5e72.gif" style="height: 25px;width: 150px;"><i class="fas fa-chevron-right"></i></div>
        </div>	
        <div class="list-item" v-if="$store.state.userInfo.isagent == 0" @click="$parent.goNav('/applyagent')">
          <div class="list-left"><div class="list-icon bg-red"><i class="fas fa-handshake"></i></div><p>合营计划</p></div>
          <div class="list-right"><span class="list-desc">加入我们，合作共赢</span><i class="fas fa-chevron-right"></i></div>
        </div>
        <div class="list-item" v-else @click="$parent.goNav('/gamePage?dailiD=1')">
          <div class="list-left"><div class="list-icon bg-red"><i class="fas fa-handshake"></i></div><p>代理登录</p></div>
          <i class="fas fa-chevron-right"></i>
        </div>
        <div class="list-item" @click="$parent.goNav('/faq')">
          <div class="list-left"><div class="list-icon bg-green"><i class="fas fa-question-circle"></i></div><p>帮助中心</p></div>
          <div class="list-right"><span class="list-desc">操作有疑问，看这里</span><i class="fas fa-chevron-right"></i></div>
        </div>
        <div class="list-item" @click="$parent.goNav('/app')">
          <div class="list-left"><div class="list-icon bg-purple"><i class="fas fa-mobile-alt"></i></div><p>下载APP</p></div>
          <i class="fas fa-chevron-right"></i>
        </div>				
        <div class="list-item" @click="$parent.goNav('/about')">
          <div class="list-left"><div class="list-icon bg-red"><i class="fas fa-info-circle"></i></div><p>关于我们</p></div>
          <i class="fas fa-chevron-right"></i>
        </div>		
      </div>
      <button class="logout-btn" @click="showLogoutPopup">退出登录</button>
    </div>
    <div class="dialog" v-if="showFuPopup">
      <div class="dialog-cover" @click="closeFuPopup"></div>
      <div class="dialog-content">
        <div class="into">
          <div class="into__header">
            <span>转入福袋</span>
            <i class="into__close" @click="closeFuPopup"></i>
          </div>
          <div class="into__content">
            <p class="into__label">可转金额 <span class="c-yellow">{{ $store.state.userInfo.balance || '0.00' }}元</span></p>
            <div class="into__input-wrapper">
              <input type="text" class="into__input" placeholder="请输入转入金额" v-model="fuAmount">
              <span class="into__text-button" @click="fillAllFu">全部</span>
            </div>
            <p class="into__label">福袋到账金额</p>
            <div class="into__input-wrapper">
              <input disabled type="text" class="into__input" :value="fuAmount || '0.00'">
            </div>
            <p class="into__label">当前汇率 <span class="c-yellow">1USDT≈6.36CNY</span>，以实际到账时为准</p>
            <button class="into__button" @click="submitFu">提交</button>
          </div>
        </div>
      </div>
    </div>
    <div class="popup" v-if="showPopup">
      <div class="popup-mask" @click="hidePopup"></div>
      <div class="popup-content">
        <i class="fas fa-times popup-close" @click="hidePopup"></i>
        <h3 class="popup-title">您确定要退出吗</h3>
        <div class="popup-btns">
          <button class="btn-cancel" @click="hidePopup">在玩一会</button>
          <button class="btn-confirm" @click="outLogin">退出登录</button>
        </div>
      </div>
    </div>
    <div class="bottom-nav-container">
      <div class="bottom-nav">
        <div class="bottom-nav-item" :class="{active: $route.path === '/activeList'}" @click="$parent.goNav('/activeList')">
          <i class="nav-icon fas fa-gift"></i>
          <span class="nav-text">优惠</span>
        </div>
        <div class="bottom-nav-item" :class="{active: $route.path === '/kefu'}" @click="$parent.goNav('/kefu')">
          <i class="nav-icon fas fa-comments"></i>
          <span class="nav-text">客服</span>
        </div>
        <div class="bottom-nav-home" :class="{active: $route.path === '/'}" @click="$parent.goNav('/')">
          <div class="home-circle"><i class="home-icon fas fa-home"></i></div>
          <span class="nav-text">首页</span>
        </div>
        <div class="bottom-nav-item" :class="{active: $route.path == '/sponsor'}" @click="$parent.goNav('/sponsor')">
          <i class="nav-icon fas fa-trophy"></i>
          <span class="nav-text">赞助</span>
        </div>
        <div class="bottom-nav-item" :class="{active: $route.path === '/userCenter'}" @click="$parent.goNav('/userCenter')">
          <i class="nav-icon fas fa-user"></i>
          <span class="nav-text">我的</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userCenter',
  data() {
    return {
      baseURL: sessionStorage.getItem('baseURL') || '',
      vipLis: [],
      bfNum: 0,
      isBalanceVisible: true,
      showPopup: false,
      showFuPopup: false,
      fuAmount: '',
      defaultAvatar: '/static/image/img1.2ceab29b.png',
      vipIconSrc: '', 
      vipIconLoaded: false 
    };
  },
  computed: {
    userVip() {
      const vip = Number(this.$store.state.userInfo.vip);
      return isNaN(vip) ? 0 : Math.max(vip, 0);
    },
    nextVipLevel() {
      if (!this.vipLis.length) return this.userVip + 1;
      const currentVipIndex = Math.min(this.userVip, this.vipLis.length - 1);
      return currentVipIndex >= this.vipLis.length - 1 ? this.userVip : this.userVip + 1;
    },
    userAvatar() {
      return this.$store.state.userInfo.avatar || this.defaultAvatar;
    },
    targetRecharge() {
      const currentVipIndex = Math.min(this.userVip, this.vipLis.length - 1);
      const currentVipItem = this.vipLis[currentVipIndex] || {};
      return Number(currentVipItem.recharge) || 0;
    },
    shouldShowVipIcon() {
      return this.vipIconLoaded && this.vipIconSrc;
    }
  },
  created() {
    this.getVipList();
    this.$nextTick(() => this.calcVipProgress());
    this.preloadVipIcon();
  },
  watch: {
    '$store.state.userInfo': {
      deep: true,
      immediate: true,
      handler: 'calcVipProgress'
    },
    'vipLis': {
      deep: true,
      handler: 'calcVipProgress'
    }
  },
  methods: {
    getVipList() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/uservip')
        .then(res => {
          this.vipLis = res.code === 200 && Array.isArray(res.data) 
            ? res.data.filter(item => item.recharge !== undefined && item.recharge !== null) 
            : [];
          if (res.code !== 200) this.$parent.showTost(0, res.message);
        })
        .finally(() => {
          this.$parent.hideLoading();
          this.calcVipProgress();
        });
    },
    calcVipProgress() {
      if (!this.vipLis.length) {
        this.bfNum = 0;
        return;
      }
      const currentVip = Math.max(this.userVip, 0);
      const userRecharge = Number(this.$store.state.userInfo.paysum) || 0;
      const targetVipIndex = Math.min(currentVip, this.vipLis.length - 1);
      const currentVipRequirement = Number(this.vipLis[targetVipIndex].recharge) || 0;
      if (currentVip >= this.vipLis.length - 1) {
        this.bfNum = 100;
        return;
      }
      if (currentVipRequirement === 0) {
        this.bfNum = 0;
        return;
      }
      const nextVipIndex = Math.min(currentVip + 1, this.vipLis.length - 1);
      const nextVipRequirement = Number(this.vipLis[nextVipIndex].recharge) || 0;
      if (nextVipRequirement > currentVipRequirement) {
        const progressWithinLevel = ((userRecharge - currentVipRequirement) / 
                                   (nextVipRequirement - currentVipRequirement)) * 100;
        this.bfNum = Math.min(Math.max(Math.round(progressWithinLevel), 0), 100);
      } else {
        this.bfNum = 100;
      }
    },
    preloadVipIcon() {
      let lastVipLevel = -1; // 记录上一次的VIP等级
      const unwatch = this.$watch('$store.state.userInfo', (userInfo) => {
        if (userInfo && this.baseURL && this.userVip !== lastVipLevel) {
          lastVipLevel = this.userVip;
          this.vipIconSrc = `${this.baseURL}/static/style/vip${this.userVip}.png`;
          const img = new Image();
          img.src = this.vipIconSrc;
          img.onload = () => {
            this.vipIconLoaded = true;
          };
          img.onerror = () => {
            const fallbackSrc = `${this.baseURL}/static/style/vip${this.userVip}.png`;
            if (fallbackSrc !== this.vipIconSrc) {
              const fallbackImg = new Image();
              fallbackImg.src = fallbackSrc;
              fallbackImg.onload = () => this.vipIconLoaded = true;
              fallbackImg.onerror = () => this.vipIconLoaded = false;
            } else {
              this.vipIconLoaded = false;
            }
          };
        }
      }, { immediate: true, deep: true });
    },
    handleVipIconError() {
      this.vipIconSrc = `${this.baseURL}/static/style/vip${this.userVip}.png`;
      this.vipIconLoaded = true;
    },
    triggerAvatarUpload() {
      if (this.$refs.avatarInput) {
        this.$refs.avatarInput.click();
      }
    },
    onchangemd(e) {
      const file = e.target.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append('file', file);
      this.$parent.showLoading();
      this.$apiFun.post('/api/uploadimg', formData)
        .then(() => {
          this.$parent.getUserInfoss();
          setTimeout(() => this.calcVipProgress(), 500);
        })
        .finally(() => this.$parent.hideLoading());
    },
    transall() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/transall')
        .then(res => {
          this.$parent.showTost(1, res.message);
          this.refreshBalance();
        })
        .finally(() => this.$parent.hideLoading());
    },
    refreshBalance() {
      this.$apiFun.post('/api/refreshusermoney')
        .then(res => {
          if (res.code === 200) {
            localStorage.setItem('userInfo', JSON.stringify(res.data));
            this.$store.commit('changUserInfo');
            this.calcVipProgress();
          }
        });
    },
    toggleBalanceVisible() {
      this.isBalanceVisible = !this.isBalanceVisible;
    },
    showLogoutPopup() {
      this.showPopup = true;
    },
    hidePopup() {
      this.showPopup = this.showFuPopup = false;
    },
    closeFuPopup() {
      this.showFuPopup = false;
    },
    fillAllFu() {
      this.fuAmount = this.$store.state.userInfo.balance || '0.00';
    },
    submitFu() {
      if (!this.fuAmount || Number(this.fuAmount) <= 0) {
        return this.$parent.showTost(0, '请输入有效金额');
      }
      this.$parent.showLoading();
      this.$apiFun.post('/api/transferToFu', { amount: this.fuAmount })
        .then(res => {
          this.$parent.showTost(1, res.message);
          this.closeFuPopup();
          this.refreshBalance();
        })
        .finally(() => this.$parent.hideLoading());
    },
    outLogin() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/logoff')
        .finally(() => {
          localStorage.clear();
          sessionStorage.clear();
          this.$store.commit('changUserInfo');
          this.$store.commit('changToken');
          setTimeout(() => {
            this.$parent.goNav('/');
            this.$parent.hideLoading();
            this.hidePopup();
          }, 1000);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$white: #ffffff;
$bg-light: #f9fafb;
$card-bg: #ffffff;
$border-light: #f0f2f5;
$blue: #165dff;
$blue-light: rgba(22, 93, 255, 0.1);
$green: #36d399;
$purple: #9333ea;
$orange: #fb923c;
$red: #ff4d4f;
$red-light: rgba(255, 77, 79, 0.1);
$text-main: #1f2937;
$text-secondary: #6b7280;
$text-light: #9ca3af;
$shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);
$transition: all 0.25s ease;
$radius: 8px;
$bottom-nav-height: 60px;
.userCenter {
  width: 100%;
  min-height: calc(100vh - #{$bottom-nav-height});
  background: $bg-light;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: calc(#{$bottom-nav-height} + 16px);
}
.user-card {
  display: flex;
  align-items: center;
  background: $card-bg;
  border-radius: $radius;
  box-shadow: $shadow-sm;
  padding: 20px 16px;
  gap: 16px;
  cursor: pointer;
  .avatar-wrap {
    position: relative;
    width: 72px;
    height: 72px;
    .avatar-img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      border: 4px solid $blue-light;
    }
    .avatar-input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      z-index: 10;
    }
    .avatar-edit-mask {
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background: rgba(0,0,0,0.3);
      color: $white;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: $transition;
      &:hover { opacity: 1; }
      .fa-camera { font-size: 20px; }
    }
  }
  .user-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    .user-name-row {
      display: flex;
      align-items: center;
      gap: 8px;
      .user-name {
        font-size: 18px;
        color: $text-main;
        font-weight: 500;
        margin: 0;
      }
      .vip-icon { 
        height: 16px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .vip-progress {
      display: flex;
      align-items: center;
      gap: 10px;
      min-height: 24px;
      width: 100%;
      .progress-bg {
        flex: 1;
        height: 10px;
        background: #e5e7eb;
        border-radius: 5px;
        overflow: hidden;
        .progress-fill {
          height: 100%;
          background: $blue;
          border-radius: 5px;
          transition: width 0.8s ease;
        }
      }
      .vip-level {
        font-size: 14px;
        color: $blue;
        font-weight: 600;
        white-space: nowrap;
        padding: 3px 8px;
        background: $blue-light;
        border-radius: 6px;
      }
    }
    .total-recharge {
      font-size: 14px;
      color: $text-secondary;
      margin: 0;
    }
  }
  .go-account {
    color: $text-light;
    transition: $transition;

    &:hover { color: $blue; }
    .fa-chevron-right { font-size: 18px; }
  }
}
.asset-card {
  background: $card-bg;
  border-radius: $radius;
  box-shadow: $shadow-sm;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 5px 0;
  .asset-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-left {
      display: flex;
      align-items: center;
      gap: 8px;
      .asset-title {
        font-size: 16px;
        color: $text-main;
        font-weight: 500;
        margin: 0;
      }
      .eye-icon {
        color: $text-light;
        cursor: pointer;
        transition: $transition;
        &:hover { color: $blue; }
      }
    }
    .recycle-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: $blue;
      cursor: pointer;
    }
  }
  .asset-value-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h2 {
      font-size: 28px;
      color: $text-main;
      font-weight: 500;
      margin: 0;
    }
    .transfer-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: $blue;
      cursor: pointer;
    }
  }
}
.function-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  .func-item {
    background: $card-bg;
    border-radius: $radius;
    box-shadow: $shadow-sm;
    padding: 12px 8px;
    cursor: pointer;
    transition: $transition;
    margin: 5px 0;
    text-align: center;
    &:hover { transform: translateY(-3px); box-shadow: $shadow-sm; }
    .func-icon {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      color: $white;
      display: inline-block;
      font-size: 18px;
      line-height: 36px; 
      &.bg-blue { background: $blue; }
      &.bg-green { background: $green; }
      &.bg-purple { background: $purple; }
      &.bg-orange { background: $orange; }
      &.bg-red { background: $red; }
    }
    p {
      font-size: 13px;
      color: $text-main;
      margin: 0;
    }
  }
}
.feature-list {
  background: $card-bg;
  border-radius: $radius;
  box-shadow: $shadow-sm;
  overflow: hidden;
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid $border-light;
    cursor: pointer;
    transition: $transition;
    &:last-child { border-bottom: none; }
    &:hover { background: $blue-light; }
    .list-left {
      display: flex;
      align-items: center;
      gap: 12px;
      .list-icon {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        color: $white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        &.bg-red { background: $red; }
        &.bg-blue { background: $blue; }
        &.bg-green { background: $green; }
        &.bg-purple { background: $purple; }
      }
      p {
        font-size: 15px;
        color: $text-main;
        margin: 0;
      }
    }
    .list-right {
      display: flex;
      align-items: center;
      gap: 8px;
      color: $text-light;
      .list-desc { font-size: 13px; color: $text-secondary; }
      .tag-red {
        font-size: 12px;
        color: $red;
        background: $red-light;
        padding: 2px 6px;
        border-radius: 4px;
      }
    }
    .fa-chevron-right {
      font-size: 14px;
      color: $text-light;
    }
  }
}
.logout-btn {
  width: 100%;
  height: 52px;
  background: $blue;
  color: $white;
  border: none;
  border-radius: $radius;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: $transition;
  margin-top: 8px;
  &:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(22, 93, 255, 0.2); }
}
.popup, .dialog {
  position: fixed;
  inset: 0;
  z-index: 9999;
}
.popup-mask, .dialog-cover {
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(2px);
}
.popup-content, .dialog-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 320px;
  background: $card-bg;
  border-radius: $radius;
  box-shadow: $shadow-sm;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.into__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 16px;
    color: $text-main;
    font-weight: 500;
  }
  .into__close {
    color: $text-light;
    cursor: pointer;
    font-size: 18px;
  }
}
.into__label {
  font-size: 14px;
  color: $text-secondary;
  margin: 0;
}
.into__input-wrapper {
  display: flex;
  gap: 8px;
  .into__input {
    flex: 1;
    height: 40px;
    padding: 0 12px;
    border: 1px solid $border-light;
    border-radius: 4px;
    outline: none;
    &:focus { border-color: $blue; }
  }
  .into__text-button {
    padding: 0 12px;
    background: $blue-light;
    color: $blue;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
}
.into__button {
  width: 100%;
  height: 44px;
  background: $blue;
  color: $white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.popup-close {
  align-self: flex-end;
  color: $text-light;
  cursor: pointer;
  font-size: 18px;
}
.popup-title {
  font-size: 16px;
  color: $text-main;
  font-weight: 500;
  text-align: center;
  margin: 0;
}
.popup-btns {
  display: flex;
  gap: 12px;
  .btn-cancel, .btn-confirm {
    flex: 1;
    height: 44px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: none;
  }
  .btn-cancel { background: $border-light; color: $text-secondary; }
  .btn-confirm { background: $blue; color: $white; }
}
.bottom-nav-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 998;
  background: $white;
  border-top: 1px solid $border-light;
  .bottom-nav {
    height: $bottom-nav-height;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 16px;
    box-sizing: border-box;
  }
}
.bottom-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $text-secondary;
  cursor: pointer;
  transition: $transition;
  padding: 8px 0;
  flex: 1;
  max-width: 80px;
  &.active, &:hover { color: $blue; }
  .nav-icon {
    font-size: 20px;
    margin-bottom: 4px;
  }
  .nav-text {
    font-size: 12px;
    font-weight: 500;
  }
}
.bottom-nav-home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $blue;
  cursor: pointer;
  flex: 1;
  max-width: 80px;
  margin-top: -20px;
  .home-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: $white;
    border: 2px solid $blue;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
    box-shadow: 0 4px 8px rgba(22,93,255,0.2);
  }
  .home-icon {
    font-size: 24px;
    color: $blue;
  }
}
@media (max-width: 375px) {
  .userCenter {
    padding: 12px;
    gap: 12px;
    padding-bottom: calc(#{$bottom-nav-height} + 12px);
  }
  .user-card {
    padding: 16px 12px;
    gap: 12px;
    .avatar-wrap { width: 64px; height: 64px; }
    .user-info .user-name { font-size: 16px; }
    .vip-progress .progress-bg { height: 8px; }
  }
  .asset-card .asset-value-row h2 { font-size: 24px; }
  .function-grid {
    gap: 8px;
    .func-item {
      padding: 12px 4px;
      .func-icon { width: 32px; height: 32px; }
      p { font-size: 12px; }
    }
  }
  .logout-btn { height: 48px; font-size: 15px; }
  .bottom-nav-home { margin-top: -18px; }
  .home-circle { width: 46px; height: 46px; }
  .home-icon { font-size: 22px; }
  .bottom-nav-item .nav-icon { font-size: 18px; }
  .bottom-nav-item .nav-text { font-size: 11px; }
}
</style>
    


// WEBPACK FOOTER //
// src/components/main/userCenter.vue